module.exports = __webpack_public_path__ + "img/w3_trash_solid_delete_dark.05117b86.png";